import { usePrivacytoString } from '../PrivacyNotices/components/PrivacytoString';
import { usePrivacytoStringEn } from '../PrivacyNotices/components/PrivacytoStringEn';
import { usePreviewtoString } from '../HRPrivacyPolicy/component/PreviewToString';
import { usePreviewtoString as rcPreview } from '../RecruitmentPolicy/component/PreviewToString';
import { usePreviewtoString as vendorPreview } from '../VenderPrivacyPolicy/component/PreviewToString';
import { usePrivacytoString as cctvPreview } from '../CCTVPolicy/components/PrivacytoString';
import { usePrivacytoString as dpaPreview } from '../DataProcessing/components/PreviewtoString';
import { useFreeFormtoString as freeformPreview } from '../FreeForm/components/PreviewtoString';
import GlobalService from '../../../services/Global.service';
import { calculateImageWidth } from '../../../util/util';

const getImage = async (companyLogoId) => {
    try {
        const { data } = await GlobalService.getImage(companyLogoId);
        if (data.resultData?.imageId) {
            return `data:image/png;base64,${data.resultData?.imageId}`;
        }
    } catch (error) {
        console.log(error);
    }
};

const PreviewtoString = ({ parse, logo }) => {
    const width = calculateImageWidth(logo);
    const { html } = usePreviewtoString(parse, 'TH', logo, width);
    const { html: htmlEn } = usePreviewtoString(parse, 'EN', logo, width);
    return {
        html,
        htmlEn,
    };
};

export const DonwloadTemplateHR = ({ detail, version, t }) => {
    const parse = JSON.parse(detail);
    const onClick = async (lang) => {
        if (parse?.hrPrivacyPolicy?.hrCompanyLogoId) {
            await getImage(parse?.hrPrivacyPolicy?.hrCompanyLogoId).then(
                (logo) => {
                    const { html, htmlEn } = PreviewtoString({
                        parse,
                        logo,
                    });
                    let blob = new Blob([lang === 'TH' ? html : htmlEn], {
                        type: 'text/html',
                    });
                    let url = URL.createObjectURL(blob);
                    window.open(url);
                }
            );
        } else {
            const { html, htmlEn } = PreviewtoString({
                parse,
                logo: '',
            });
            let blob = new Blob([lang === 'TH' ? html : htmlEn], {
                type: 'text/html',
            });
            let url = URL.createObjectURL(blob);
            window.open(url);
        }
    };

    return (
        <div className="col-span-2 flex flex-col">
            <button
                type="button"
                onClick={() => onClick('TH')}
                className="text-[#1890FF] font-semibold underline cursor-pointer text-sm text-left"
            >
                {t('Download document version')} {version} - TH
            </button>
            <button
                type="button"
                onClick={() => onClick('EN')}
                className="text-[#1890FF] font-semibold underline cursor-pointer text-sm text-left"
            >
                {t('Download document version')} {version} - EN
            </button>
        </div>
    );
};

const PreviewVendortoString = ({ parse, logo }) => {
    const width = calculateImageWidth(logo);
    const { html } = vendorPreview(parse, 'TH', logo, width);
    const { html: htmlEn } = vendorPreview(parse, 'EN', logo, width);
    return {
        html,
        htmlEn,
    };
};

export const DonwloadTemplateVendor = ({ detail, version, t }) => {
    const parse = JSON.parse(detail);
    const onClick = async (lang) => {
        if (parse?.vendorPrivacyPolicy?.vendorCompanyLogoId) {
            await getImage(
                parse?.vendorPrivacyPolicy?.vendorCompanyLogoId
            ).then((logo) => {
                const { html, htmlEn } = PreviewVendortoString({
                    parse,
                    logo,
                });
                let blob = new Blob([lang === 'TH' ? html : htmlEn], {
                    type: 'text/html',
                });
                let url = URL.createObjectURL(blob);
                window.open(url);
            });
        } else {
            const { html, htmlEn } = PreviewVendortoString({
                parse,
                logo: '',
            });
            let blob = new Blob([lang === 'TH' ? html : htmlEn], {
                type: 'text/html',
            });
            let url = URL.createObjectURL(blob);
            window.open(url);
        }
    };

    return (
        <div className="col-span-2 flex flex-col">
            <button
                type="button"
                onClick={() => onClick('TH')}
                className="text-[#1890FF] font-semibold underline cursor-pointer text-sm text-left"
            >
                {t('Download document version')} {version} - TH
            </button>
            <button
                type="button"
                onClick={() => onClick('EN')}
                className="text-[#1890FF] font-semibold underline cursor-pointer text-sm text-left"
            >
                {t('Download document version')} {version} - EN
            </button>
        </div>
    );
};

const PreviewRctoString = ({ parse, logo }) => {
    const width = calculateImageWidth(logo);
    const { html } = rcPreview(parse, 'TH', logo, width);
    const { html: htmlEn } = rcPreview(parse, 'EN', logo, width);
    return {
        html,
        htmlEn,
    };
};

export const DonwloadTemplateRecruitment = ({ detail, version, t }) => {
    const parse = JSON.parse(detail);

    const onClick = async (lang) => {
        if (parse?.recruitmentPrivacyPolicy?.recruitmentCompanyLogoId) {
            await getImage(
                parse?.recruitmentPrivacyPolicy?.recruitmentCompanyLogoId
            ).then((logo) => {
                const { html, htmlEn } = PreviewRctoString({
                    parse,
                    logo,
                });
                let blob = new Blob([lang === 'TH' ? html : htmlEn], {
                    type: 'text/html',
                });
                let url = URL.createObjectURL(blob);
                window.open(url);
            });
        } else {
            const { html, htmlEn } = PreviewRctoString({
                parse,
                logo: '',
            });
            let blob = new Blob([lang === 'TH' ? html : htmlEn], {
                type: 'text/html',
            });
            let url = URL.createObjectURL(blob);
            window.open(url);
        }
    };

    return (
        <div className="col-span-2 flex flex-col">
            <button
                type="button"
                onClick={() => onClick('TH')}
                className="text-[#1890FF] font-semibold underline cursor-pointer text-sm text-left"
            >
                {t('Download document version')} {version} - TH
            </button>
            <button
                type="button"
                onClick={() => onClick('EN')}
                className="text-[#1890FF] font-semibold underline cursor-pointer text-sm text-left"
            >
                {t('Download document version')} {version} - EN
            </button>
        </div>
    );
};

const PrivacytoString = ({ parse, logo }) => {
    const width = calculateImageWidth(logo);
    const { html } = usePrivacytoString(parse, logo, width);
    const { html: htmlEn } = usePrivacytoStringEn(parse, logo, width);
    return {
        html,
        htmlEn,
    };
};

export const DonwloadTemplatePrivacy = ({ detail, version, t }) => {
    const parse = JSON.parse(detail);
    const onClick = async (lang) => {
        if (parse?.personalDataCollection?.companyLogoId) {
            await getImage(parse?.personalDataCollection?.companyLogoId).then(
                (logo) => {
                    const { html, htmlEn } = PrivacytoString({ parse, logo });
                    let blob = new Blob([lang === 'TH' ? html : htmlEn], {
                        type: 'text/html',
                    });
                    let url = URL.createObjectURL(blob);
                    window.open(url);
                }
            );
        } else {
            const { html, htmlEn } = PrivacytoString({ parse, logo: '' });
            let blob = new Blob([lang === 'TH' ? html : htmlEn], {
                type: 'text/html',
            });
            let url = URL.createObjectURL(blob);
            window.open(url);
        }
    };

    return (
        <div className="col-span-2 flex flex-col">
            <button
                type="button"
                onClick={() => onClick('TH')}
                className="text-[#1890FF] font-semibold underline cursor-pointer text-sm text-left"
            >
                {t('Download document version')} {version} - TH
            </button>
            <button
                type="button"
                onClick={() => onClick('EN')}
                className="text-[#1890FF] font-semibold underline cursor-pointer text-sm text-left"
            >
                {t('Download document version')} {version} - EN
            </button>
        </div>
    );
};

const PrivacyCCTVtoString = ({ parse, logo }) => {
    const width = calculateImageWidth(logo);
    const { html } = cctvPreview(parse, 'TH', logo, width);
    const { html: htmlEn } = cctvPreview(parse, 'EN', logo, width);
    return {
        html,
        htmlEn,
    };
};

export const DonwloadTemplateCCTV = ({ detail, version, t }) => {
    const parse = JSON.parse(detail);
    const onClick = async (lang) => {
        if (parse?.cctvPolicy?.cctvCompanyLogoId) {
            await getImage(parse?.cctvPolicy?.cctvCompanyLogoId).then(
                (logo) => {
                    const { html, htmlEn } = PrivacyCCTVtoString({
                        parse,
                        logo,
                    });
                    let blob = new Blob([lang === 'TH' ? html : htmlEn], {
                        type: 'text/html',
                    });
                    let url = URL.createObjectURL(blob);
                    window.open(url);
                }
            );
        } else {
            const { html, htmlEn } = PrivacyCCTVtoString({
                parse,
                logo: '',
            });
            let blob = new Blob([lang === 'TH' ? html : htmlEn], {
                type: 'text/html',
            });
            let url = URL.createObjectURL(blob);
            window.open(url);
        }
    };

    return (
        <div className="col-span-2 flex flex-col">
            <button
                type="button"
                onClick={() => onClick('TH')}
                className="text-[#1890FF] font-semibold underline cursor-pointer text-sm text-left"
            >
                {t('Download document version')} {version} - TH
            </button>
            <button
                type="button"
                onClick={() => onClick('EN')}
                className="text-[#1890FF] font-semibold underline cursor-pointer text-sm text-left"
            >
                {t('Download document version')} {version} - EN
            </button>
        </div>
    );
};

// DPA download

export const DonwloadTemplateDPA = ({ detail, version, t }) => {
    const parse = JSON.parse(detail);
    const onClick = async () => {
        const { html } = dpaPreview(parse);
        let blob = new Blob([html], {
            type: 'text/html',
        });
        let url = URL.createObjectURL(blob);
        window.open(url);
    };

    return (
        <div className="col-span-2 flex flex-col">
            <button
                type="button"
                onClick={() => onClick('TH')}
                className="text-[#1890FF] font-semibold underline cursor-pointer text-sm text-left"
            >
                {t('Download document version')} {version} - TH
            </button>
        </div>
    );
};

const PreviewFreeformtoString = ({ parse, logo }) => {
    const width = calculateImageWidth(logo);
    const { html } = freeformPreview(parse, 'th', logo, width);
    const { html: htmlEn } = freeformPreview(parse, 'en', logo, width);
    return {
        html,
        htmlEn,
    };
};

export const DownloadFreeForm = ({ detail, version, t }) => {
    const parse = JSON.parse(detail);
    const onClick = async (lang) => {
        if (parse?.freeFormPolicy?.freeFormCompanyLogoId) {
            await getImage(parse?.freeFormPolicy?.freeFormCompanyLogoId).then(
                (logo) => {
                    const { html, htmlEn } = PreviewFreeformtoString({
                        parse,
                        logo,
                    });
                    let blob = new Blob([lang === 'TH' ? html : htmlEn], {
                        type: 'text/html',
                    });
                    let url = URL.createObjectURL(blob);
                    window.open(url);
                }
            );
        } else {
            const { html, htmlEn } = PreviewFreeformtoString({
                parse,
                logo: '',
            });
            let blob = new Blob([lang === 'TH' ? html : htmlEn], {
                type: 'text/html',
            });
            let url = URL.createObjectURL(blob);
            window.open(url);
        }
    };

    return (
        <div className="col-span-2 flex flex-col">
            <button
                type="button"
                onClick={() => onClick('TH')}
                className="text-[#1890FF] font-semibold underline cursor-pointer text-sm text-left"
            >
                {t('Download document version')} {version} - TH
            </button>
            <button
                type="button"
                onClick={() => onClick('EN')}
                className="text-[#1890FF] font-semibold underline cursor-pointer text-sm text-left"
            >
                {t('Download document version')} {version} - EN
            </button>
        </div>
    );
};
